export const HEADER_BLOCK_S11 = {
  "blockType": "HEADER",
  "blockDesign": "HeaderDesign2",
  "editFormName": "HEADER_04_FORM",
  "styleProps": {
    "background-image": "",
    "background-color": "#D0ECF5",
    "padding": "120px 20px 120px 20px"
  },
  "textBlock": {
    "styleProps": {
      "background-color": "",
      "border-radius": "0",
      "padding": "10px 10px 10px 10px"
    },
    "stylePropsTab": {},
    "stylePropsMob": {},
    "alingBlock": "center",
    "headings": [
      {
        "text": "Transforming Businesses with Innovative Software Solutions",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "1px"
        },
        "styleProps": {
          "color": "#161c26",
          "font-size": "4.5rem",
          "line-height": "1",
          "font-family": "'Source Serif 4'",
          "font-weight": "500",
          "font-family-cust": "Source Serif 4",
          "font-family-bk": "'Source Serif 4', cursive"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "10px 20px 10px 20px",
          "margin": "10px 0px 40px 0px"
        },
        "stylePropsMob": {
          "font-size": "3rem",
          "line-height": "1"
        },
        "stylePropsTab": {
          "font-size": "3.75rem",
          "line-height": "1"
        },
        "alignStylePropsTab": {
          "margin": "10px 0px 30px 0px"
        },
        "alignStylePropsMob": {
          "margin": "10px 0px 20px 0px"
        }
      },
      {
        "text": "✔ Empowering growth, <br>✔ efficiency, and success through<br> ✔ cutting-edge technology.",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#161c26",
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "0px 220px 0px 20px"
        },
        "alignStylePropsMob": {
          "padding": "0px 20px 0px 20px"
        }
      }
    ],
    "dynamicText": {
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "strings": []
    },
    "descriptionsStyleProps": {
      "padding": "10px 0px 10px 0px",
      "text-align": "center",
      "margin": "0px 0px 0px 0px"
    },
    "descriptionsStylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptionsStylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptions": [],
    "buttonsStyleProps": {
      "margin": "50px 0px 0px 10px"
    },
    "buttonAlign": "start",
    "buttons": [
      {
        "text": "Learn more ➜",
        "styleProps": {
          "color": "#ffffff",
          "background-color": "#161c26",
          "border-width": "0px",
          "border-radius": "9999px",
          "padding": "10px 32px 10px 32px",
          "font-weight": "400",
          "font-size": "1.125rem",
          "line-height": "1.75rem"
        },
        "href": "#",
        "openType": "sametab"
      }
    ],
    "emailSecStyleProps": {},
    "subscription": {
      "showSection": "hide",
      "display": "enable",
      "subConfigs": {
        "configType": "convertkit",
        "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
        "configPlaceholder": ""
      },
      "email_placeholder": {
        "text": "example@mail.com"
      },
      "buttonText": {
        "text": "Subscribe",
        "styleProps": {
          "background-color": "#1b1b31",
          "color": "#ffffff"
        }
      },
      "successMessage": {
        "text": "Thank you for the signup",
        "styleProps": {}
      },
      "errorMessage": {
        "text": "Something went wrong. Please try again.",
        "styleProps": {}
      }
    }
  },
  "imageType": "image",
  "imageVideoPostion": "right",
  "imageBlock": {
    "image": "https://d11lx8wl9i3fvs.cloudfront.net/1723883803066/1745700289746.png",
    "styleProps": {
      "margin": "0px 0px 0px 0px",
      "border-radius": "0px",
      "background-color": "",
      "box-shadow": "",
      "background-size": "auto"
    },
    "imageTag": {
      "styleProps": {
        "border-radius": "1.5rem"
      }
    },
    "tagStyleProps": {
      "border-radius": "0px",
      "border-width": "0px",
      "border-color": "#ffa611",
      "box-shadow": ""
    },
    "outerStyleProps": {
      "box-shadow": "",
      "border-radius": "0px",
      "background-color": ""
    }
  },
  "videoBlock": {
    "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    },
    "videoHeight": {
      "height": "400px"
    }
  },
  "htmlBlock": {
    "value": "",
    "styleProps": {}
  },
  "metaDataId": 1745700709472,
  "afterIndex": 0,
  "blockId": 1745700709472,
  "buttons": [
    {
      "text": "Click Here",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "fonts": {
    "textBlock": "Source Serif 4"
  },
  "position": "hide",
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}